module.exports = __webpack_public_path__ + "static/media/download.694dd342.svg";